const PickFilesReducer = (state, action) => ({
  ...state,
  newFiles: action.payload.newFiles
});
export default PickFilesReducer;
